import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'

import l10n from '../../i18n/I18N'
import { CryptoPaymentDepositCurrencyIcon } from '../CryptoPaymentDeposit/CryptoPaymentDepositCurrencyIcon'

import classes from './cryptoPaymentModalSuccess.module.scss'

export const CryptoPaymentModalSuccess = () => {
  const { handleCloseCryptoPaymentModal, withdrawalResponseData } = useCryptoPaymentDataModal()

  return (
    <>
      <div className={classes.cryptoPaymentModalSuccess__header}>{l10n.t['cryptopayment.redeem.success.header']}</div>
      <div className={classes.cryptoPaymentModalSuccess__text}>{l10n.t['cryptopayment.redeem.success.text']}</div>
      <div className={classes.cryptoPaymentModalSuccess__amountBox}>
        <CryptoPaymentDepositCurrencyIcon currencyCode={withdrawalResponseData.currency} />
        &nbsp;
        <span className={classes.cryptoPaymentModalSuccess__amount}>{withdrawalResponseData.amount}</span>
      </div>
      <button className={classes.cryptoPaymentModalSuccess__button} onClick={handleCloseCryptoPaymentModal}>
        {l10n.t['cryptopayment.redeem.success.confirm']}
      </button>
    </>
  )
}
